import {
    ProduktAuswahlDatenEntry,
    ProduktAuswahlOberkategorie
} from "../../../konfi_mobile/src/store/ProduktAuswahlStore";

export function sortProduktauswahlIntoOberkategorien(categories: ProduktAuswahlDatenEntry[]) {

    return categories.reduce((carry, cat) => {
        let currentContainer = carry.find(oc => oc.oberkategorieName === cat.oberkategorie);
        if (currentContainer === undefined) {
            currentContainer = new ProduktAuswahlOberkategorie(cat.oberkategorie);
            carry.push(currentContainer);
        }
        currentContainer.categories.push(cat);
        return carry;
    }, [] as ProduktAuswahlOberkategorie[])

}